/** Google Play feature graphic — 1024×500 (see /ad/sliding-master-feature-graphic). */
export const FEATURE_GRAPHIC_W = 1024;
export const FEATURE_GRAPHIC_H = 500;

export const SLIDING_MASTER_FEATURE_STORY_ID = "a5364e08-d60d-4aee-8e00-9e952b0221d2";
export const SLIDING_MASTER_FEATURE_GRID_SIZE = 6;
export const SLIDING_MASTER_FEATURE_LEVEL = "MEDIUM";
